import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const redingtonShoresConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Redington Shores Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Redington Shores, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_redington_shores',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Redington Shores',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

   /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Redington Shores Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve the waterfront and residential 
     properties of <strong>Redington Shores</strong> with professional tree care 
     designed for coastal conditions. Trees here grow in challenging environments
     sandy, salt laden soil combined with Gulf wind exposure means root systems weaken 
     faster and canopies become storm liabilities sooner than in inland areas. We 
     identify those hazards and handle them before they cause damage.`,

    `We specialize in <strong>coastal tree removal and precision trimming</strong> 
     palms and hardwoods with compromised root systems, overgrown canopies near 
     homes and vacation rentals, large limbs hanging over driveways and seawalls, 
     and full tree removals on narrow beachside lots where access and precision 
     are critical.`,

    `<strong>Sam's Tree Service</strong> brings reliable, expert tree care to 
     <strong>Redington Shores</strong> and the full <strong>South Pinellas 
     beachfront</strong> corridor protecting your property and keeping your 
     landscape healthy and storm ready year round.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Redington Shores, FL',
};


// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_RedingtonShores = () => <LocationPage config={redingtonShoresConfig} />;
export default Services_RedingtonShores;
